<template>
    <section>
		<div class="filters">
			<div class="checkbox-filter bg-call" @click="inCallFilter = !inCallFilter">
				<input class="form-control" type="checkbox" name="incall" v-model="inCallFilter">
				<span>Em ligação</span>
			</div>
        	<div class="checkbox-filter bg-pause" @click="pausedFilter = !pausedFilter">
				<input class="form-control" type="checkbox" name="paused" v-model="pausedFilter">
				<span>Em pausa</span>
        	</div>
        	<div class="select-filter bg-status" :class="{'bg-success': statusFilter === true, 'bg-danger': statusFilter === false, 'bg-secondary': statusFilter === '*'}">
				<span>Status: </span>
				<select class="form-control" v-model="statusFilter">
					<option value="*">Todos</option>
					<option :value="true">Online</option>
					<option :value="false">Offline</option>
				</select>
        	</div>
        	<input type="text" v-model="keyword" placeholder="🔎  Busque por nome, fila ou ramal..." class="form-control">
      	</div>
      	<div v-if="filteredUsers.length" class="or-users-table-wrapper">
        	<b-table
				table-class="or-users-table"
				:items="filteredUsers"
				:fields="fields"
				:per-page="perPage"
				:current-page="currentPage"
				striped
				hover
				bordered
				outlined
				fixed
				small
				responsive
				sort-by="status"
				:sort-desc="true"
				@filtered="onFiltered"
        	>
          		<template #cell(name)="data">
					<span v-if="data.item.active == 1" title="Supervisor"><i class="fas fa-user text-danger"></i><strong>     {{ data.item.name }}</strong></span>
					<span v-if="data.item.active == 2" title="Operador"><i class="fas fa-user text-primary"></i><strong>     {{ data.item.name }}</strong></span>
          		</template>
          		<template #cell(extension_line)="data">
					<strong>{{ data.item.extension_line }}</strong>
          		</template>
          		<template #cell(queues)="data">
            		<div v-if="data.item.queues.length">
              			<span v-for="q in data.item.queues" 
              			  	:key="q.name" 
              			  	class="badge custom-queue-badge" 
              			  	:class="{'bg-pause cursor-help': q.status === 'paused'}"
              			  	:title="q.status === 'paused' ? `${q.pauseReason} ● ${secondsToString(q.lastPause)}` : 'Ativo na fila' "
              			>
                			<i v-if="q.status === 'paused'" class="fas fa-pause"></i>
                			<i v-else class="fas fa-play"></i>
                			{{ q.name }}
              			</span>
            		</div>
            		<div v-else>
						<span class="badge custom-queue-badge" style="background-color: gray;">Deslogado</span>
            		</div>
          		</template>
          		<template #cell(status)="data">
					<span v-if="data.item.status" class="text-success">
          		    	<i class="fas fa-circle text-success fa-beat-fade icon-extension-status" style="--fa-animation-duration: 1.5s;"></i><strong>Online</strong>
          		  	</span>
          		  	<span v-else class="text-danger">
						<i class="fas fa-circle text-danger icon-extension-status"></i><strong>Offline</strong>
          		  	</span>
          		</template>
          		<template #cell(paused)="data">
          		  	<div v-if="data.item.paused" class="paused">
						<i class="fas fa-pause"></i>     {{ data.item.pauseReason }} ● {{ secondsToTime(data.item.lastPause) }} 
          		  	</div>
          		  	<div v-else class="unpaused">
						<i class="fas fa-play"></i>     Ativo
          		  	</div>
          		</template>
          		<template #cell(inCall)="data">
					<div v-if="data.item.inCall" class="incall">
          		    	<div class="call-info">
          		      		<div v-if="data.item.callStatus === 'active'" class="call-icons">
								<div v-if="data.item.callType === 'incoming'" title="Ligação entrante - em curso">
          		          			<i class="fas fa-phone text-success"></i>
          		          			<i class="fas fa-arrow-down text-success"></i>
          		        		</div>
          		        		<div v-else-if="data.item.callType === 'outgoing'" title="Ligação sainte - em curso">
									<i class="fas fa-phone text-danger"></i>
									<i class="fas fa-arrow-up text-danger"></i>
          		        		</div>
          		      		</div>
          		      		<div v-else-if="data.item.callStatus === 'ringing'"  class="call-icons">
          		        		<div v-if="data.item.callType === 'incoming'" title="Ligação entrante - Tocando">
									<i class="fas fa-volume-control-phone fa-beat-fade ringing-icon"></i>
									<i class="fas fa-arrow-down fa-beat-fade ringing-icon"></i>
          		        		</div>
          		        		<div v-else-if="data.item.callType === 'outgoing'" title="Ligação sainte - Chamando">
									<i class="fas fa-volume-control-phone fa-beat-fade ringing-icon"></i>
									<i class="fas fa-arrow-up fa-beat-fade ringing-icon"></i>
          		        		</div>
          		      		</div>
          		      		{{ data.item.callNumber }} 
          		    	</div>
          		    	{{ secondsToTime(data.item.callDuration) }}
          		  	</div>
          		  	<div v-else class="available">
						<i class="fas fa-phone"></i>     Disponível
          		  	</div>
          		</template>
        	</b-table>
      	</div>
      	<div v-else>
			<div v-if="!reconnection" class="alert alert-warning">Não há usuários para exibir</div>
			<div v-else class="alert alert-danger">Reconectando ao serviço do Realtime...</div>
      	</div>
      	<div class="table-footer">
			<div class="per-page-selector">
      	    	<span>Registros por página: </span>          
      	    	<select class="form-control" v-model="perPage">
      	      		<option value="10">10</option>
      	      		<option value="30">30</option>
      	      		<option value="50">50</option>
      	      		<option value="70">70</option>
      	      		<option value="100">100</option>
      	    	</select>
      	  	</div>
      	  	<b-pagination
      	  	    v-if="filteredUsers.length"
      	  	    v-model="currentPage"
      	  	    :total-rows="totalRows"
      	  	    :per-page="perPage"
      	  	    align="right"
      	  	    size="md"
      	  	    class="my-0"
      	  	></b-pagination>
      	</div>
    </section>
</template>
  
<script>
  // @ts-nocheck
export default {
	name: 'OrUsersTable',
	props: [
		'usersList',
		'queueList',
		'currentCalls',
		'peersStatus',
		'queueMembers',
		'socketClient',
		'reconnection',
		'enabledListeners'
	],
	data() {
		return {
			fields: [
				{ key: 'name', label: 'Nome', sortable: true, 'thClass': 'or-custom-header', tdClass: 'align-content-center'},
				{ key: 'extension_line', label: 'Ramal', sortable: true, 'thClass': 'or-custom-header small-column', tdClass: 'text-center fw-bold align-content-center'},
				{ key: 'status', label: 'Status', sortable: true, 'thClass': 'or-custom-header small-column', tdClass: 'text-center  align-content-center'},
				{ key: 'queues', label: 'Filas', sortable: true, 'thClass': 'or-custom-header', tdClass: 'text-center  align-content-center'},
				{ key: 'inCall', label: 'Ligação', sortable: true, 'thClass': 'or-custom-header', tdClass: 'text-center  align-content-center'},
			],
			perPage: 10,
			currentPage: 1,
			totalRows: 0,
			keyword: '',
			inCallFilter: false,
			pausedFilter: false,
			statusFilter: '*',
			callTimer: null,
			pauseTimer: null
		};
	},
	computed: {
	filteredUsers(){
		let filteredUsers = this.updatedUsers;

		if (this.statusFilter !== '*') {
			filteredUsers = filteredUsers.filter(user => 
				user.status === this.statusFilter
			);
		}

		if (this.inCallFilter && this.pausedFilter) {
			filteredUsers = filteredUsers.filter(user => 
				user.inCall || user.queues.some(el => el.status === 'paused')
			);
		} else if (this.inCallFilter) {
			filteredUsers = filteredUsers.filter(user => user.inCall);
		} else if (this.pausedFilter) {
			filteredUsers = filteredUsers.filter(user => 
				user.queues.some(el => el.status === 'paused')
			);
		}

		if(this.keyword){
			const keyword = this.keyword.trim().toLowerCase();

			filteredUsers = filteredUsers.filter(user => {

				// NOME
				const matchesName = user.name
					? user.name.toLowerCase().includes(keyword)
					: false;

				// RAMAL
				const matchesExtension = user.extension_line
					? user.extension_line.toString().includes(keyword)
					: false;

				// FILAS EM QUE ESTÁ LOGADO AGORA
				const matchesLoggedQueues = user.queues.some(q =>
					q.name &&
					q.name.toLowerCase().includes(keyword)
				);

				// FILAS CADASTRADAS NO BANCO
				let queueIds = [];

				try {
					queueIds = user.queue
						? JSON.parse(user.queue)
						: [];
				} catch (e) {
					queueIds = [];
				}

				const matchesRegisteredQueues = queueIds.some(queueId => {

					const queue = this.queueList.find(q =>
						String(q.id) === String(queueId) ||
						String(q.value) === String(queueId)
					);

					if (!queue) {
						return false;
					}

					const queueName =
						queue.name ||
						queue.text ||
						queue.label ||
						'';

					return queueName
						.toLowerCase()
						.includes(keyword);
				});

				return (
					matchesName ||
					matchesExtension ||
					matchesLoggedQueues ||
					matchesRegisteredQueues
				);
			});
		}

		return filteredUsers;
	},

		updatedUsers() {
			const arr = []

			this.usersList.map(el => {
				const obj = {
					...el,

					// Filas cadastradas no usuário, vindas do /list-queues-users
					registeredQueues: el.queues || [],

					status: false,
					inCall: false,
					callDuration: null,
					callNumber: null,
					callType: null,

					// Filas onde está logado atualmente no Asterisk
					queues: []
				}

				arr.push(obj)
			})

			return arr
		},

		updatedUsersMap() {
			const map = new Map();
			this.updatedUsers.forEach(user => map.set(user.extension_line, user));
			return map;
		}
	},
	mounted(){
		this.totalRows = this.updatedUsers.length;
	},
	watch: {
		filteredUsers() {
			this.totalRows = this.filteredUsers.length;
		},
		peersStatus: { //Ramal online e offline - Dados da requisição "sip-peers"
			handler(value){
				if(value.length){
					value.map(el => {
						const found = this.updatedUsers.find(usr => usr.extension_line == el.extension_line)
						if(found) found.status = el.status
					})
				}
			},
			deep: true
		},
		queueMembers: { //Filas do ramal e pausa - Dados da requisiçao "queue-member"
			handler(value){
				if(value.length){
					value.map(el => {
						const found = this.updatedUsers.find(usr => usr.extension_line == el.extension_line)
						if(found){
							if(!found.queues.some(q => q.name === el.queue)) found.queues.push({name: el.queue, status: 'logged'})
							if(el.paused){
								const pauseReason = !el.pause_reason ? 'Pausa no ramal' : el.pause_reason
								const lastPause = el.last_pause
								if(found.queues.length){
									found.queues.map(fq => {
										if(fq.name === el.queue){
											fq.status = 'paused'
											fq.pauseReason = pauseReason
											fq.lastPause = parseInt(lastPause)
										}
									})
								}
							}
						}
					})
					this.$nextTick(async () => {
						this.calcPauseTimer()
					});
				}
			},
			deep: true
		},
		currentCalls: { //Ligações em curso - Dados da requisiçao "core-show-channels"`
			handler(value){
				if(value.length){
					value.map(async el => {
						await this.handleCall(el)
					})
					this.$nextTick(async () => {
						this.calcCallTimer()
					});
				}
			},
			deep: true
		},
		"enabledListeners.currentCalls":{
			handler(value){
				if(value) this.enableListeners('currentCalls')
			}
		},
		"enabledListeners.queueMembers":{
			handler(value){
				if(value) this.enableListeners('queueMembers')
			}
		},
		"enabledListeners.peerStatus":{
			handler(value){
				if(value) this.enableListeners('peerStatus')
			}
		},
	},
	methods: {
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},	
		secondsToTime(seconds) {
			const hours = Math.floor(seconds / 3600);
			const minutes = Math.floor((seconds % 3600) / 60);
			const secs = seconds % 60;
			
			const pad = (num) => String(num).padStart(2, '0');
			
			return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
		},
		secondsToString(seconds) {
			if (seconds < 60) return "Há menos de um minuto";
	
			const minutes = Math.floor(seconds / 60);
			if (minutes < 60) return `Há mais de ${minutes} minuto${minutes > 1 ? "s" : ""}`;
			
			const hours = Math.floor(minutes / 60);
			const remainingMinutes = minutes % 60;
			
			if (remainingMinutes === 0) return `Há mais de ${hours} hora${hours > 1 ? "s" : ""}`;
		
			return `Há mais de ${hours} hora${hours > 1 ? "s" : ""} e ${remainingMinutes} minuto${remainingMinutes > 1 ? "s" : ""}`;
		},
		timeToSeconds(time) {
			const [hours, minutes, seconds] = time.split(':').map(num => parseInt(num, 10));
			return (hours * 3600) + (minutes * 60) + seconds;
		},
		calcPauseTimer(){
			clearInterval(this.pauseTimer);
			this.pauseTimer = setInterval(() => {
				this.updatedUsers.map((el) => {
					if(el.queues.length){
						if(el.queues.some(el => el.status === 'paused')){
							el.queues.map(q => {
								if(q.status === 'paused'){
									q.lastPause = q.lastPause + 60
									this.$forceUpdate();
								}
							})
						}
					}
				})
			}, 60000)
		},
		calcCallTimer(){
			clearInterval(this.callTimer);
			this.callTimer = setInterval(() => {
				this.updatedUsers.map((el) => {
					if(el.inCall) el.callDuration++
				})
			}, 1000)
		},
		async enableListeners(type){
			if(!this.socketClient) return
		
			if(type === 'currentCalls'){
				this.socketClient.removeAllListeners('ringingCall');
				this.socketClient.removeAllListeners('callInProgress');
				this.socketClient.removeAllListeners('hangup');

				this.socketClient.on('ringingCall', async (data) => {
					await this.handleCall(data)
				})
				
				this.socketClient.on('callInProgress', async (data) => {
					await this.handleCall(data)
				})
				
				this.socketClient.on('hangup', async (data) => {
					await this.handleHangup(data)
				})
			}
		
			if(type === 'queueMembers'){
				this.socketClient.removeAllListeners('agentQueueLogin');
				this.socketClient.removeAllListeners('agentQueueLogoff');
				this.socketClient.removeAllListeners('agentPause');
				this.socketClient.removeAllListeners('agentUnpause');
				this.socketClient.removeAllListeners('agentDnd');

				this.socketClient.on('agentQueueLogin', async (data) => {
					await this.handleLoginLogoff(data, 'login')
				})
				
				this.socketClient.on('agentQueueLogoff', async (data) => {
					await this.handleLoginLogoff(data, 'logoff')
				})
				
				this.socketClient.on('agentPause', async (data) => {
					await this.handlePause(data, 'pause')
				})
				
				this.socketClient.on('agentUnpause', async (data) => {
					await this.handlePause(data, 'unpause')
				})
				
				this.socketClient.on('agentDnd', async (data) => {
					// await this.handleEvent('agentDnd', data)
				})
			}

			if(type === 'peerStatus'){
				this.socketClient.removeAllListeners('peerStatusUpdate');

				this.socketClient.on('peerStatusUpdate', async (data) => {
					await this.handleStatusUpdate(data)
				})
			}
		},
		async handleCall(data){
			if(data.type === 'outgoing'){ // Chamadas saintes - atualizar no ramal de origem
				const user = this.updatedUsersMap.get(parseInt(data.origin));
				if(user){
					user.inCall = true
					user.callNumber = data.destiny
					user.callType = data.type
					user.callStatus = data.status
					user.callDuration = this.timeToSeconds(data.duration)
				}
			} else if(data.type === 'incoming'){ // Chamadas entrantes - atualizar no ramal de destino
				const user = this.updatedUsersMap.get(parseInt(data.destiny));
				if(user){
					user.inCall = true
					user.callNumber = data.origin
					user.callType = data.type
					user.callStatus = data.status
					user.callDuration = this.timeToSeconds(data.duration)
				}
			} else if(data.type === 'intercom'){ // Chamadas ramal x ramal - atualizar nos dois
				const userOrigin = this.updatedUsersMap.get(parseInt(data.origin));
				const userDestiny = this.updatedUsersMap.get(parseInt(data.destiny));

				if(userOrigin){
					userOrigin.inCall = true
					userOrigin.callNumber = data.destiny
					userOrigin.callType = 'outgoing'
					userOrigin.callStatus = data.status
					userOrigin.callDuration = this.timeToSeconds(data.duration)
				}
				
				if(userDestiny){
					userDestiny.inCall = true
					userDestiny.callNumber = data.origin
					userDestiny.callType = 'incoming'
					userDestiny.callStatus = data.status
					userDestiny.callDuration = this.timeToSeconds(data.duration)
				}
			}
		},
		async handleHangup(data){
			const user = this.updatedUsersMap.get(parseInt(data.extension));

			if(user && user.inCall){
				user.inCall = false
				user.callNumber = null
				user.callType = null
				user.callStatus = null
				user.callDuration = null
			}
		},
		async handleLoginLogoff(data, type){
			const user = this.updatedUsersMap.get(parseInt(data.extension));
			let findQueue;
			if(user){
				if(user.queues.length) findQueue = user.queues.find(q => q.name === data.queue)
			}
			if(type === 'login'){
				if(!findQueue) user.queues.push({name: data.queue, status: 'logged'})
			} else {
				if(findQueue){
					const index = user.queues.findIndex(q => q.name === data.queue);
					if (index !== -1) user.queues.splice(index, 1);
				}
			}
		},
		async handlePause(data, type){
			const user = this.updatedUsersMap.get(parseInt(data.extension));
			let findQueue;
			if(user){
				if(user.queues.length) findQueue = user.queues.find(q => q.name === data.queue)
			}
			if(type === 'pause'){
				if(findQueue){ 
					const pauseReason = !data.reason ? 'Pausa no ramal' : data.reason
					const lastPause = 0
					findQueue.status = 'paused'
					findQueue.pauseReason = pauseReason
					findQueue.lastPause = parseInt(lastPause)
				}
			} else {
				if(findQueue){
					findQueue.status = 'logged'
					delete findQueue.pauseReason;
					delete findQueue.lastPause;
				}
			}
		},
		async handleStatusUpdate(data){
			const user = this.updatedUsersMap.get(parseInt(data.extension));
			if(user && user.status !== data.status) user.status = data.status
		}
	},
};
</script>
  
<style lang="scss" scoped>
.filters {
  margin: 15px;
  display: flex;
  gap: 20px;

  .checkbox-filter {
    display: flex;
    gap: 5px;
    border-radius: 10px;
    padding: 0 5px;
    box-shadow: 1px 1px 3px gray;
    cursor: pointer;
    transition: 0.3s;

    input {
      cursor: pointer;
      height: 100%;

      &:focus {
        outline: none;
        box-shadow: none;
      }
    }

    span {
      font-weight: bold;
      white-space: nowrap;
      align-content: center;
      color: white;
    }

    &:hover {
      filter: brightness(0.8);
    }
  }

  .select-filter {
    min-width: fit-content;
    display: flex;
    gap: 5px;
    border-radius: 10px;
    box-shadow: 1px 1px 3px gray;
    font-weight: bold;
    padding-left: 5px;
    transition: 0.3s;

    select {
      border-radius: 0 10px 10px 0 !important;
      cursor: pointer;
    }

    span {
      font-weight: bold;
      white-space: nowrap;
      align-content: center;
      color: white;
    }
  }

  
  .bg-pause {
    background-color: #c2b049;
  }

  .bg-call {
    background-color: #2a95b1;
  }
}
.or-users-table-wrapper{
  	max-height: 68vh;
  	overflow-y: auto;
  	margin: 10px;

  	::v-deep(.table-responsive) {
  	  	border-radius: 10px 10px 0 0;
  	  	box-shadow: 1px 1px 3px 1px #0000001f
  	}

  	::v-deep(.or-custom-header){
  	  	font-weight: bold;
  	  	text-align: center;
  	  	background-color: #1c869a;
  	  	color: white
  	}

  	::v-deep(.small-column){
  	  	width: 100px;
  	  	text-align: center;
  	}

  	.icon-extension-status {
  	  	align-self: center;
  	  	margin-right: 5px;
  	}

  	.custom-queue-badge {
  	  	background-color: #287228;
  	  	border-radius: 5px;
  	  	padding: 2px 5px 2px 5px;
  	  	margin: 2px;
  	  	color: white;
  	}

  	.incall {
  	  	font-size: smaller;
  	  	font-weight: bold;
  	  	background-color: #2a95b1;
  	  	color: white;
  	  	border-radius: 10px;
  	  	display: flex;
  	  	justify-content: space-between;
  	  	padding: 2px 10px 2px 10px;

  	  	.call-info {
  	  	  	display: flex;
  	  	  	gap: 10px;
  	  	}

  	  	.call-icons {
  	  	  	display: flex;
  	  	  	gap: 5px;
  	  	  	align-items: center;

  	  	  	.ringing-icon {
  	  	  	  	color: darkblue;
  	  	  	}
  	  	}
  	}

  	.available {
  	  	font-size: small;
  	  	font-weight: bold;
  	  	background-color: #aaa;
  	  	border-radius: 10px;
  	}

  	.paused {
  	  	font-size: small;
  	  	font-weight: bold;
  	  	background-color: #c2b049;
  	  	color: white;
  	  	border-radius: 10px;
  	}

  	.unpaused {
  	  	font-size: small;
  	  	font-weight: bold;
  	  	background-color: #71a17c;
  	  	color: white;
  	  	border-radius: 10px;
  	}

  	.cursor-help {
  	  	cursor: help;
  	}

  	.bg-pause {
  	  	background-color: #c2b049;
  	}
}

.table-footer {
  	display: flex;
  	justify-content: space-between;

  	.per-page-selector {
  	  	display: flex;
  	  	gap: 5px;
  	  	white-space: nowrap;
  	  	border-radius: 10px;
  	  	box-shadow: 1px 1px 3px gray;
  	  	font-weight: bold;
  	  	padding-left: 5px;
  	  	transition: 0.3s;
  	  	background-color: #1c869a;
  	  	color: white;
		
  	  	span {
  	  	  	align-content: center;
  	  	  	font-weight: bold;
  	  	}
	  
  	  	select {
  	  	  	border-radius: 0 10px 10px 0 !important;
  	  	  	cursor: pointer;
  	  	}
  	}
}

::v-deep(.page-link) {
  	font-weight: bold;
  	border: none;
  	border-radius: 10px !important;
  	padding: 5px 10px;
  	transition: 0.3s;
  	margin: 2px;
  	background-color: transparent;
	
  	&:hover {
  	  	background-color: #1c859a85;
  	}
}

::v-deep(.page-link[aria-checked="true"]) {
  	background-color: #1c869a;
}

::v-deep(.page-link[aria-checked="false"]) {
  	color: #1c869a;
}

::v-deep(.page-link[aria-label="Go to next page"]) {
  	color: #1c869a;
}

::v-deep(.page-link[aria-label="Go to previous page"]) {
  	color: #1c869a;
}

::v-deep(.page-link[aria-label="Go to first page"]) {
  	color: #1c869a;
}

::v-deep(.page-link[aria-label="Go to last page"]) {
  	color: #1c869a;
}
</style>
  